import React from 'react';

import classnames from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import { HybridLink } from 'common/components';

import './TopBorderedColumnsGrid.scss';

type ItemType = {
  title?: string;
  link?: string;
  content: React.ReactElement;
};

type CustomNumberType = {
  numberContent: string;
};

interface Props {
  items: ItemType[];
  blockTitle?: string;
  titleClass?: string;
  blockTitleClass?: string;
  containerClass?: string;
  isCounter?: boolean;
  counterStartIndex?: number;
  gridAdditionalClass?: string;
  titleCustomNumber?: CustomNumberType[];
  titleCustomClass?: string;
  noBorderTop?: boolean;
  columnsNumber?: number;
  hasLogoAsTitle?: boolean;
  smallRowGap?: boolean;
  largeColumnGap?: boolean;
}

export const TopBorderedColumnsGrid = ({
  items,
  blockTitle,
  titleClass,
  containerClass,
  blockTitleClass,
  titleCustomNumber,
  titleCustomClass,
  counterStartIndex = 0,
  isCounter = false,
  gridAdditionalClass,
  noBorderTop = false,
  columnsNumber = 0,
  hasLogoAsTitle = false,
  smallRowGap = false,
  largeColumnGap = false,
}: Props) => {
  const mainGridClasses = classnames(
    'main-grid',
    gridAdditionalClass,
    `columns-count-${columnsNumber}`,
    { 'no-border': noBorderTop },
    { 'small-row-gap': smallRowGap },
    { 'large-column-gap': largeColumnGap },
  );

  const itemClasses = classnames(
    'main-grid-item top-bordered-columns-item',
    { 'no-border': noBorderTop },
    { 'has-logo-as-title': hasLogoAsTitle },
  );

  return (
    <div className={classnames('top-bordered-columns', containerClass)}>
      {blockTitle && <h3 className={classnames(blockTitleClass)}>{blockTitle}</h3>}
      <div className={mainGridClasses}>
        {items.map(({ title, link, content }, index) => (
          <div key={uuidv4()} className={itemClasses}>
            {link ? (
              <div className="title-with-link">
                {isCounter && <span className="title-number">{index + 1 + counterStartIndex} </span>}
                <HybridLink to={link} ariaLabel={title && title}>
                  {title && (
                    <h3 className={classnames('top-bordered-columns-title', titleClass, { 'link-hover': link })}>
                      {titleCustomNumber && (
                        <span className={classnames(titleCustomClass)}>{titleCustomNumber[index].numberContent}</span>
                      )}
                      {title}
                    </h3>
                  )}
                </HybridLink>
              </div>
            ) : (
              title && (
                <h3 className={classnames('top-bordered-columns-title', titleClass)}>
                  {titleCustomNumber && (
                    <span className={classnames(titleCustomClass)}>{titleCustomNumber[index].numberContent}</span>
                  )}
                  {isCounter && <span className="title-number">{index + 1 + counterStartIndex} </span>}
                  {title}
                </h3>
              )
            )}
            {content}
          </div>
        ))}
      </div>
    </div>
  );
};
